import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=952b20ea&scoped=true&lang=pug"
import script from "./admin.vue?vue&type=script&lang=js"
export * from "./admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952b20ea",
  null
  
)

export default component.exports